const isLastStep = (step: number) => step === 5;

const isFirstStep = (step: number) => step === 0;

export { isFirstStep, isLastStep };
